import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Attachment from './Attachment';
import './AttachmentList.scss';
class AttachmentList extends PureComponent {
  constructor(props) {
    super(props);
    this.toggleShowAll = () => {
      const {
        showAll
      } = this.state;
      this.setState({
        showAll: !showAll
      });
    };
    this.state = {
      showAll: false
    };
  }
  render() {
    const {
      files,
      maxCount,
      canDelete,
      onClick,
      onDeleteFile,
      showThumbnail,
      downloadAttachmentWithPresignedUrl
    } = this.props;
    const {
      showAll
    } = this.state;
    const filesToRender = !showAll && maxCount > 0 ? files.slice(0, maxCount) : files;
    const remainingFilesCount = files.length - maxCount;
    return /*#__PURE__*/React.createElement("div", {
      className: "tap-attachments"
    }, filesToRender.map(file => /*#__PURE__*/React.createElement(Attachment, {
      showThumbnail: showThumbnail,
      key: file.url,
      file: file,
      canDelete: canDelete,
      onClick: e => onClick && onClick(file, e),
      onDeleteFile: onDeleteFile,
      downloadAttachmentWithPresignedUrl: downloadAttachmentWithPresignedUrl
    })), (showAll || remainingFilesCount > 0) && /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment view-more",
      role: "button",
      tabIndex: "0",
      onClick: this.toggleShowAll
    }, /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-name"
    }, showAll ? __('Show Less') : "+".concat(remainingFilesCount, " ").concat(__("more files..."))))));
  }
}
AttachmentList.propTypes = {
  files: PropTypes.array,
  maxCount: PropTypes.number,
  canDelete: PropTypes.bool,
  onClick: PropTypes.func,
  onDeleteFile: PropTypes.func,
  showThumbnail: PropTypes.bool
};
AttachmentList.defaultProps = {
  files: [],
  maxCount: 3,
  canDelete: false,
  onClick: null,
  onDeleteFile: null,
  showThumbnail: true
};
export default AttachmentList;